export default __webpack_public_path__ + "static/media/Kujawa.c39bb104.jpg";